import { EffectType, IVectorEffect } from '@/version-types';

export const hasReflection = ({ reflection }: IVectorEffect) => {
    if (!reflection) {
        return false;
    }
    return reflection[0]?.hidden === false && reflection[0]?.size > 0;
};

export const hasShadow = ({ shadow }: IVectorEffect) => {
    return shadow[0]?.hidden === false;
};

export const getBlurOrReflectionParams = (val: number, type: EffectType) => {
    const baseValue = Math.floor(val / 6);
    const params = {
        shadow: { XY: `-${(baseValue + 1) * 25}%`, WH: `${baseValue * 50 + 150}%` },
        reflection: {
            XY: `-${(baseValue + 1) * 50}%`,
            WH: `${baseValue * 50 + 300}%`,
        },
    };
    return params[type];
};
